<template>
  <div class="consulting-container">
    <div class="consulting-title">{{ manifestoDetails.consultTitle }}</div>
    <div class="consulting-txt">{{ manifestoDetails.consultIntroduction }}</div>
    <div class="consulting-list">
      <div class="list-item" v-for="item in  consultingList" :key="item.name">
        <div class="list-item-img">
          <imgContainer :src="item.url" />
        </div>
        <div class="list-item-name">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps} from "vue";
import imgContainer from '@/components/imgContainer/index.vue'
let prop = defineProps({
  manifestoDetails: {
    type: Object,
    default: () => {
    },
  }
})
const consultingList = computed(function () {
  if (prop.manifestoDetails.consultContent) {
    return JSON.parse(prop.manifestoDetails.consultContent)
  }
  return []
})
</script>

<style lang="scss" scoped>
.consulting-container {
  width: 1200px;
  margin: 70px auto 0 auto;
}

.consulting-title {
  font-weight: bold;
  font-size: 28px;
  color: #242424;
  text-align: center;
}

.consulting-txt {
  font-size: 20px;
  color: #242424;
  margin-top: 16px;
  text-align: center;
}

.consulting-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  row-gap:30px;
  column-gap:10px;
}
.list-item{
  position: relative;
}
.list-item-img {
  width: 292px;
  height: 210px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.list-item-name{
  width: 100%;
  height: 48px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  font-size: 20px;
  color: #FFFFFF;
  line-height: 48px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
